import React, {useEffect, useState, useRef, useContext} from 'react';
import {PageHeader, Table, Input, Button, Space, notification} from 'antd';
import {getWelcomelist, getWelcomeAttachList, delWelcomeConfig} from '@/api/customer';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {FileOutlined, PlusOutlined, DeleteOutlined, EditOutlined} from '@/icons';
import styles from '@/page/customer/index.module.less';
import classNames from 'classnames';
import WelcomeModal from '@/page/customer/WelcomPage/WelcomeModal';
import MsgContext from '@/page/customer/WelcomPage/msgContext';
import {formatLong} from '@/util/dateUtils';
import {PageGrid} from '@/component';
import {getAttach} from '@/api/attach';

export default function WelcomPage() {
    const [authStore] = useAuthStore();
    const extId = _.get(authStore, 'user.extId');
    const [viewText, setViewText] = useState(null);
    const [viewLinks, setViewLinks] = useState([]);
    const [viewImages, setViewImages] = useState([]);
    const [url, setUrl] = useState(null);
    const [sender, setSender] = useState(extId);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [count, setCount] = useState(0);
    const [names, setNames] = useState('');

    const wlRef = useRef();
    const tableRef = useRef();

    const columns = [
        {
            title: '配置id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '生效员工',
            dataIndex: 'extId',
            key: 'extId',
        },
        {
            title: '欢迎文字',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            render: text => {
                return formatLong(text);
            },
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            render: (text, record) => (
                <Space>
                    <Button type="link" icon={<FileOutlined />} onClick={() => view(record)}>
                        查看详细
                    </Button>
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => {
                            edit(record);
                        }}
                    >
                        编辑
                    </Button>
                    <Button
                        danger
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            del(record);
                        }}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ];

    let extra = (
        <Button type="primary" icon={<PlusOutlined />} onClick={add}>
            添加
        </Button>
    );

    useEffect(() => {
        setUrl('/customer/welcome/list?extId=' + extId);
        // init();
    }, []);

    function add() {
        reset();
        wlRef.current.open(1);
    }

    function del(record) {
        delWelcomeConfig(record.id).then(res => {
            init();
            notification.success({
                message: '删除成功',
            });
        });
    }

    function edit(record) {
        reset();
        setViewText(record.content);
        getWelcomeAttachList(record.id).then(res => {
            if (res.data.length > 0) {
                let imageArr = [];
                let linkArr = [];
                res.data.forEach(item => {
                    item.msgType === 'link' &&
                        linkArr.push({
                            title: item.title,
                            desc: item.linkDesc,
                            url: item.url,
                            attachId: item.mediaAttachId,
                            picurl: item.picUrl,
                        });
                    if (item.msgType === 'image') {
                        imageArr.push(item.sysAttach);
                    }
                });
                setViewLinks(linkArr);
                setViewImages(imageArr);
            }
            setTimeout(() => {
                wlRef.current.open(2, record.id);
            }, 500);
        });
    }

    function view(record) {
        reset();
        setViewText(record.content);
        getWelcomeAttachList(record.id).then(res => {
            if (res.data.length > 0) {
                let imageArr = [];
                let linkArr = [];
                res.data.forEach(item => {
                    item.msgType === 'link' &&
                        linkArr.push({
                            title: item.title,
                            desc: item.linkDesc,
                            url: item.url,
                            attachId: item.mediaAttachId,
                            picurl: item.picUrl,
                        });
                    if (item.msgType === 'image') {
                        imageArr.push(item.sysAttach);
                    }
                });
                setViewImages(imageArr);
                setViewLinks(linkArr);
            }

            wlRef.current.open(3);
        });
    }

    function reset() {
        setViewImages([]);
        setViewText(null);
        setViewLinks([]);
        setSelectedUsers([]);
        setNames('');
        setCount(0);
        setSelectedUsers([]);
    }

    function init() {
        // getWelcomelist(extId).then(res => {
        //     console.log(res);
        // });
        tableRef.current.reload2FirstPage();
    }

    return (
        <MsgContext.Provider
            value={{
                viewText,
                setViewText,
                viewImages,
                setViewImages,
                viewLinks,
                setViewLinks,
                sender,
                selectedUsers,
                setSelectedUsers,
                count,
                setCount,
                names,
                setNames,
            }}
        >
            <div className={styles.header}>
                <PageHeader title={'客户欢迎语配置'} extra={extra} />
            </div>
            <div className={classNames(styles.tableContainer, styles.tabContainer)}>
                {url && <PageGrid ref={tableRef} url={url} columns={columns} />}
            </div>
            <WelcomeModal ref={wlRef} reload={init} />
        </MsgContext.Provider>
    );
}
